import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VALID_PATTERN } from '../constants/lib-constants';

@Component({
  selector: 'ra-add-new-dialog',
  templateUrl: './add-new-dialog.component.html',
  styleUrls: ['./add-new-dialog.component.scss'],
  standalone: false,
})
export class AddNewDialogComponent implements OnInit {
  regEx = VALID_PATTERN;
  aggregateForm = new FormGroup({
    aggregateFileName: new FormControl(null, [
      Validators.required,
      Validators.pattern(this.regEx),
    ]),
  });
  error: string;
  showSpinner = false;

  get aggregateFileName() {
    return this.aggregateForm.get('aggregateFileName').value;
  }
  set aggregateFileName(value: string) {
    this.aggregateForm.get('aggregateFileName').setValue(value);
  }

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<AddNewDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.aggregateForm
      .get('aggregateFileName')
      .valueChanges.subscribe((value) => {
        this.aggregateForm
          .get('aggregateFileName')
          .setValue(value.toLowerCase(), { emitEvent: false });
      });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.showSpinner = true;
    this.dialogRef.close(this.aggregateForm.get('aggregateFileName').value);
  }
}
